var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "btn-group" }, [
    _vm.canToggle
      ? _c(
          "button",
          {
            staticClass: "btn btn-sm",
            class: [_vm.isBound ? "btn-danger" : "btn-secondary"],
            on: { click: _vm.toggle },
          },
          [
            _c("i", {
              staticClass: "fas",
              class: [_vm.isBound ? "fa-unlink" : "fa-link"],
            }),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }